/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_DraftInputs */

const en_directory_submit_workspace_aside_draft = /** @type {(inputs: Directory_Submit_Workspace_Aside_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save draft and choose a plan`)
};

const zh_directory_submit_workspace_aside_draft = /** @type {(inputs: Directory_Submit_Workspace_Aside_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存草稿并选择方案`)
};

/**
* | output |
* | --- |
* | "Save draft and choose a plan" |
*
* @param {Directory_Submit_Workspace_Aside_DraftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_draft = /** @type {((inputs?: Directory_Submit_Workspace_Aside_DraftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_DraftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_draft(inputs)
	return zh_directory_submit_workspace_aside_draft(inputs)
});
export { directory_submit_workspace_aside_draft as "directory.submit.workspace.aside.draft" }